import { useTranslation } from '../i18n'
import SEO from '../components/SEO'
import HowItWorksSection from '../components/sections/HowItWorks'
import DownloadCTA from '../components/sections/DownloadCTA'
import './HowItWorksPage.css'

function HowItWorksPage() {
  const { t } = useTranslation()

  const techStack = [
    {
      icon: '🖥️',
      titleKey: 'techDesktopTitle',
      descKey: 'techDesktopDesc',
      tags: ['Tauri', 'Rust', 'React', 'TypeScript'],
    },
    {
      icon: '🎤',
      titleKey: 'techSpeechTitle',
      descKey: 'techSpeechDesc',
      tags: ['Whisper', 'Cloud STT', 'Local STT'],
    },
    {
      icon: '👁️',
      titleKey: 'techScreenTitle',
      descKey: 'techScreenDesc',
      tags: ['Tesseract', 'OCR', 'Cloud OCR', 'Local OCR'],
    },
    {
      icon: '🧠',
      titleKey: 'techAiTitle',
      descKey: 'techAiDesc',
      tags: ['FastAPI', 'Python', 'LLM', 'WebSocket', 'Local LLM'],
    },
  ] as const

  const faqs = [
    { questionKey: 'faq1Question', answerKey: 'faq1Answer' },
    { questionKey: 'faq2Question', answerKey: 'faq2Answer' },
    { questionKey: 'faq3Question', answerKey: 'faq3Answer' },
    { questionKey: 'faq4Question', answerKey: 'faq4Answer' },
    { questionKey: 'faq5Question', answerKey: 'faq5Answer' },
  ] as const

  return (
    <>
      <SEO
        title="How It Works"
        description="Learn how Intervio works: real-time audio capture, screen OCR, AI-powered transcription with cloud or local models, intelligent question detection, and instant hint generation."
        path="/how-it-works"
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: faqs.map((faq) => ({
            '@type': 'Question',
            name: t(faq.questionKey),
            acceptedAnswer: {
              '@type': 'Answer',
              text: t(faq.answerKey),
            },
          })),
        }}
      />
      <section className="how-hero">
        <div className="container">
          <h1>{t('howItWorksPageTitle')}</h1>
          <p>{t('howItWorksPageSubtitle')}</p>
        </div>
      </section>

      <HowItWorksSection />

      <section className="section tech-stack">
        <div className="container">
          <div className="section-title">
            <h2>{t('techStackTitle')}</h2>
            <p>{t('techStackSubtitle')}</p>
          </div>

          <div className="tech-grid">
            {techStack.map((tech, index) => (
              <div key={index} className="tech-card">
                <div className="tech-header">
                  <span className="tech-icon">{tech.icon}</span>
                  <h3>{t(tech.titleKey)}</h3>
                </div>
                <p>{t(tech.descKey)}</p>
                <div className="tech-tags">
                  {tech.tags.map((tag, tidx) => (
                    <span key={tidx}>{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section faq-section section-gray">
        <div className="container">
          <div className="section-title">
            <h2>{t('faqTitle')}</h2>
          </div>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <h3>{t(faq.questionKey)}</h3>
                <p>{t(faq.answerKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <DownloadCTA />
    </>
  )
}

export default HowItWorksPage
